import { SpacerWrappper } from "./styles"

const Spacer = SpacerWrappper

export default Spacer
